import { lazyPage } from '@/lib/lazy-load'

const MyNotificationSettingsPage = lazyPage(() => import('./MyNotificationSettingsPage'))
export default MyNotificationSettingsPage
